import { Injectable } from '@angular/core';
import { ListingExportConfig } from '@portal/shared/types/listing.types';
import { ExportRow } from '@portal/shared/types/export.types';
import { TableData } from '@portal/shared/types/api-response.types';
import { MissingProgrammingRecordsListItem } from '../missing-programming-records.types';
import { mapMissingProgrammingRecordToExport } from './missing-programming-records-listing.export';

@Injectable()
export class MissingProgrammingRecordsListingExportConfigService implements ListingExportConfig {
  readonly fileName = 'Export-MissingProgrammingRecords';

  readonly mapData = (data: TableData<MissingProgrammingRecordsListItem>): ExportRow[] =>
    data.data.map(mapMissingProgrammingRecordToExport);
}
